var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 萝卜丝第三方应用 重定向中，请稍后... ")])}
var staticRenderFns = []

export { render, staticRenderFns }